import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';

/**
 * Route guard for the tenant UI config admin surface (`/admin/configs`).
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `ui_config.manage` is present. Tenant users
 * — and any super_user without the explicit grant — are bounced to `/home`.
 *
 * Auth0 plays no part in the decision: this is purely the backend's
 * permission set, surfaced via the API response.
 */
export const uiConfigAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes('ui_config.manage')) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
